import { json_headers, request } from './common';

const basePath = (appName: string) => {
  return `${window.configs.API_HOST}/api/${appName}/aws`;
};

export interface IAwsJob {
  name: string;
  info: {
    count: number;
    delayed: number;
    active: number;
    failed: number;
  };
}

interface IAwsResponse<R> {
  status: number;
  message: string;
  result: R | null;
}

export const getJobs = (appName: string): Promise<IAwsResponse<IAwsJob[]>> => {
  const url = `${basePath(appName)}/jobs`;
  return request(url, {
    method: `GET`,
    headers: json_headers,
  });
};

export const getJob = (appName: string, jobName: string): Promise<IAwsResponse<IAwsJob>> => {
  const url = `${basePath(appName)}/jobs/${jobName}`;
  return request(url, {
    method: `GET`,
    headers: json_headers,
  });
};

export const restoreFailedJobs = (appName: string, jobName: string): Promise<IAwsResponse<null>> => {
  const url = `${basePath(appName)}/jobs/${jobName}/restore/failed`;
  return request(url, {
    method: `POST`,
    headers: json_headers,
  });
};
